/**
 * usePageTitle (TMMPDM-0065, TMM-B7) — the page's `document.title`, "Page · TMM Product Admin". The
 * most specific part comes first: a detail page is "Acme Resale · Partners · TMM Product Admin".
 * Every route renders a `PageHeader` or an `ObjectHeader` (which call this) or, for the few screens
 * with their own heading, calls it with that heading.
 */
import { useEffect } from 'react';
import { useCopy } from '@/hooks/useCopy';

export function usePageTitle(...parts: string[]): void {
  const { t } = useCopy();
  const title = [...parts.filter((part) => part !== ''), t('app.name', 'TMM Product Admin')].join(
    ' · ',
  );
  useEffect(() => {
    document.title = title;
  }, [title]);
}

/** A heading and the crumbs above it, most specific first, without repeating the heading. */
export function titleParts(heading: string, crumbs: { label: string }[] | undefined): string[] {
  const above = [...(crumbs ?? [])].reverse().map((crumb) => crumb.label);
  return [heading, ...above.filter((label) => label !== heading)];
}
